import { useState } from "react";
import { BASE_URL } from "../../config";
import { setToken } from "../../utils/auth";

export default function LoginTwoFactorStep({
  pendingToken,
  verificationMethod,
  onCancel,
  onSuccess,
}) {
  const [code, setCode] = useState("");
  const [trustDevice, setTrustDevice] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const masked =
    verificationMethod?.email ||
    verificationMethod?.emailMasked ||
    "your email";

  const handleVerify = async () => {
    setError("");
    setLoading(true);
    try {
      const verifyUrl = `${BASE_URL}/auth/login/verify-2fa`;
      const res = await fetch(verifyUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          pendingToken,
          code,
          trustDevice,
        }),
      });
      const data = await res.json();
      if (!res.ok || !data.token) {
        throw new Error(data.message || "Invalid verification code");
      }
      setToken(data.token);
      if (data.user?.account_id) {
        localStorage.setItem("accountId", String(data.user.account_id));
      }
      if (data.user?.type) {
        localStorage.setItem("userType", String(data.user.type).toLowerCase());
      }
      onSuccess?.(data);
    } catch (err) {
      setError(err.message || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setError("");
    setLoading(true);
    try {
      const resendUrl = `${BASE_URL}/auth/login/resend-2fa`;
      const res = await fetch(resendUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pendingToken }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        throw new Error(data.message || "Resend failed");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <h2 className="text-xl font-semibold mb-2 text-center">
        2-Step Verification
      </h2>
      <p className="text-sm text-gray-600 text-center mb-4">
        Enter the verification code sent to {masked}
      </p>
      <input
        type="text"
        inputMode="numeric"
        maxLength={6}
        value={code}
        onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
        className="w-full border px-3 py-3 mb-3 text-center tracking-widest text-lg"
        placeholder="000000"
      />
      <label className="flex items-center gap-2 text-sm text-gray-700 mb-4">
        <input
          type="checkbox"
          checked={trustDevice}
          onChange={(e) => setTrustDevice(e.target.checked)}
          className="accent-[#DC1F00]"
        />
        Trust this device
      </label>
      {error && <p className="text-sm text-red-600 mb-3 text-center">{error}</p>}
      <div className="flex flex-col gap-2">
        <button
          type="button"
          onClick={handleVerify}
          disabled={loading || code.length !== 6}
          className="w-full py-2 bg-buttonRed text-white rounded disabled:opacity-50"
        >
          Verify
        </button>
        <button
          type="button"
          onClick={handleResend}
          disabled={loading}
          className="w-full py-2 text-buttonRed"
        >
          Resend
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="w-full py-2 text-gray-600"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
